import FillButton from '@components/Buttons/Fill';
import styled from '@emotion/styled';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;

export const FloatingArea = styled.div`
  position: absolute;
  top: 136px;
  right: 14px;
  display: flex;
  gap: 8px;
  width: max-content;
  z-index: 10;
`;

export const HelpButton = styled(FillButton)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 86px;
  height: 36px;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  background: #6d64e5;
  border-radius: 4px;
`;

export const HelpIcon = styled.div`
  width: 22px;
  height: 22px;
  background: url('/img/help.png') no-repeat center center;
`;
